<div class="background">
    <mat-card class="chemical-compare-card">

        <!-- Header -->
        <div class="chemical-compare-header-container">
            <div class="chemical-compare-info">
                <p class="chemical-compare-header-text">Chemical Compare View</p>
                <div class="field-info-text-container">
                    <span class="field-detail-title">Field Name: </span>
                    <span>{{fieldName || '-'}}</span>
                    <span> | </span>
                    <span class="field-detail-title">Field Size: </span>
                    <span>{{fieldSize ? (fieldSize | number: '1.2-2') : '-'}} HA</span>
                </div>
            </div>

            <div>
                <mat-slide-toggle [(ngModel)]="showLegendsToggle" (change)="toggleLegends()">Toggle Legends</mat-slide-toggle>
            </div>

            <div class="zoom-controls">
                <button class="zoom-btn" mat-icon-button (click)="zoomIn()" title="Zoom In"><img src="../../assets/icons/zoom_in.svg" alt="Zoom In" class="move-job-icon"></button>
                <button class="zoom-btn" mat-icon-button (click)="zoomOut()" title="Zoom Out"><img src="../../assets/icons/zoom_out.svg" alt="Zoom Out" class="move-job-icon"></button>
                <button class="zoom-btn reset-btn" mat-icon-button (click)="resetMaps()" title="Reset Maps"><img src="../../assets/icons/reset.svg" alt="Reset" class="move-job-icon"></button>
            </div>

            <div class="input-container-close">
                <div class="close-icon-container-chemical-compare"><img src="../../../assets/icons/close.svg" alt="Close"
                    class="close-icon-chemical-compare" (click)="closeView()"></div>
            </div>
        </div>

        <!-- Selectors row -->
        <div class="chem-compare-selectors-row">
            <div class="chem-compare-selectors">
                <mat-form-field appearance="outline" class="chem-compare-field" subscriptSizing="dynamic" style="flex: 1;">
                    <mat-label>Soil Type</mat-label>
                    <mat-select [(ngModel)]="chemCompareLeft.soilType" (selectionChange)="onSoilTypeChange(chemCompareLeft)">
                        <mat-option value="TOP_SOIL">Top Soil</mat-option>
                        <mat-option value="SUB_SOIL">Sub Soil</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline" class="chem-compare-field" subscriptSizing="dynamic" style="flex: 1;">
                    <mat-label>Year</mat-label>
                    <mat-select [(ngModel)]="chemCompareLeft.selectedYear" [disabled]="!chemCompareLeft.soilType" (selectionChange)="onYearChange(chemCompareLeft)">
                        <mat-option *ngFor="let year of chemCompareLeft.availableYears" [value]="year">{{year}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="chem-compare-divider"></div>
            <div class="chem-compare-selectors">
                <mat-form-field appearance="outline" class="chem-compare-field" subscriptSizing="dynamic" style="flex: 1;">
                    <mat-label>Soil Type</mat-label>
                    <mat-select [(ngModel)]="chemCompareRight.soilType" (selectionChange)="onSoilTypeChange(chemCompareRight)">
                        <mat-option value="TOP_SOIL">Top Soil</mat-option>
                        <mat-option value="SUB_SOIL">Sub Soil</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline" class="chem-compare-field" subscriptSizing="dynamic" style="flex: 1;">
                    <mat-label>Year</mat-label>
                    <mat-select [(ngModel)]="chemCompareRight.selectedYear" [disabled]="!chemCompareRight.soilType" (selectionChange)="onYearChange(chemCompareRight)">
                        <mat-option *ngFor="let year of chemCompareRight.availableYears" [value]="year">{{year}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <!-- Shared scroll area for both columns -->
        <div class="chem-compare-content">
            <!-- LEFT SIDE -->
            <div class="chem-compare-column">
                <ng-container *ngFor="let pair of alignedEntries; let i = index">
                    <div class="chem-compare-entry" *ngIf="pair.left; else leftPlaceholder">
                        <div class="chem-compare-map-wrapper">
                            <google-map
                                *ngIf="pair.left.mapUrl && pair.left.bounds"
                                [center]="getEntryCenter(pair.left)"
                                [options]="mapOptions"
                                width="100%"
                                height="100%"
                                (mapDragend)="onMapDragEnd(getVisibleIndex('L', i))"
                                (zoomChanged)="onMapZoomChanged(getVisibleIndex('L', i))">
                                <map-ground-overlay [url]="pair.left.mapUrl" [bounds]="getEntryBounds(pair.left)" [opacity]="1"></map-ground-overlay>
                                <map-polygon *ngFor="let path of fieldPolygon" [paths]="path" [options]="polygonOptions"></map-polygon>
                            </google-map>
                            <div *ngIf="pair.left.mapUrl && pair.left.bounds" class="chem-compare-overlay-label glassMorphism-effect">
                                <p class="chem-compare-overlay-title">{{pair.left.propertyTypeName}}</p>
                                <p class="chem-compare-overlay-year">{{chemCompareLeft.selectedYear}}</p>
                            </div>
                            <div *ngIf="pair.left.mapUrl && !pair.left.bounds" class="chem-compare-no-data">Loading...</div>
                            <div *ngIf="showLegends && getLegends(pair.left).length > 0" class="chem-compare-legend">
                                <div *ngFor="let legend of getLegends(pair.left)" class="chem-compare-legend-item">
                                    <div class="chem-compare-legend-color" [style.background-color]="legend.color"></div>
                                    <span class="chem-compare-legend-value">{{legend.value}}</span>
                                </div>
                            </div>
                            <div *ngIf="!pair.left.mapUrl" class="chem-compare-no-data">No data</div>
                        </div>
                    </div>
                    <ng-template #leftPlaceholder>
                        <div class="chem-compare-entry">
                            <div class="chem-compare-map-wrapper">
                                <div class="chem-compare-no-data chem-compare-placeholder">No data available</div>
                            </div>
                        </div>
                    </ng-template>
                </ng-container>
                <div *ngIf="alignedEntries.length === 0 && chemCompareLeft.entries.length === 0" class="chem-compare-empty">Select a year to view chemicals</div>
            </div>

            <!-- RIGHT SIDE -->
            <div class="chem-compare-column">
                <ng-container *ngFor="let pair of alignedEntries; let i = index">
                    <div class="chem-compare-entry" *ngIf="pair.right; else rightPlaceholder">
                        <div class="chem-compare-map-wrapper">
                            <google-map
                                *ngIf="pair.right.mapUrl && pair.right.bounds"
                                [center]="getEntryCenter(pair.right)"
                                [options]="mapOptions"
                                width="100%"
                                height="100%"
                                (mapDragend)="onMapDragEnd(getVisibleIndex('R', i))"
                                (zoomChanged)="onMapZoomChanged(getVisibleIndex('R', i))">
                                <map-ground-overlay [url]="pair.right.mapUrl" [bounds]="getEntryBounds(pair.right)" [opacity]="1"></map-ground-overlay>
                                <map-polygon *ngFor="let path of fieldPolygon" [paths]="path" [options]="polygonOptions"></map-polygon>
                            </google-map>
                            <div *ngIf="pair.right.mapUrl && pair.right.bounds" class="chem-compare-overlay-label glassMorphism-effect">
                                <p class="chem-compare-overlay-title">{{pair.right.propertyTypeName}}</p>
                                <p class="chem-compare-overlay-year">{{chemCompareRight.selectedYear}}</p>
                            </div>
                            <div *ngIf="pair.right.mapUrl && !pair.right.bounds" class="chem-compare-no-data">Loading...</div>
                            <div *ngIf="showLegends && getLegends(pair.right).length > 0" class="chem-compare-legend">
                                <div *ngFor="let legend of getLegends(pair.right)" class="chem-compare-legend-item">
                                    <div class="chem-compare-legend-color" [style.background-color]="legend.color"></div>
                                    <span class="chem-compare-legend-value">{{legend.value}}</span>
                                </div>
                            </div>
                            <div *ngIf="!pair.right.mapUrl" class="chem-compare-no-data">No data</div>
                        </div>
                    </div>
                    <ng-template #rightPlaceholder>
                        <div class="chem-compare-entry">
                            <div class="chem-compare-map-wrapper">
                                <div class="chem-compare-no-data chem-compare-placeholder">No data available</div>
                            </div>
                        </div>
                    </ng-template>
                </ng-container>
                <div *ngIf="alignedEntries.length === 0 && chemCompareRight.entries.length === 0" class="chem-compare-empty">Select a year to view chemicals</div>
            </div>
        </div> 
    </mat-card> 
</div>
